import React from 'react';
import { Row as VDSRow, Col as VDSCol, Grid } from '@vds/grids';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { Line } from '@vds/lines';

import Checkbox from '../../../common/CheckBox/index';
import Button from '../../../common/Button';
import { goToProcessStep } from '../../../../redirection';
import ReqInput from '../../../common/ReqInput/index';
import { Micro, Body } from '../../../common/Typography/index';
import VdsTooltip from '../../../common/Tooltip';
import Notification from '../../../common/Notification/index';
import EmailInput from '../../../common/EmailInput';
import { normalizePhoneNumber, isValidEmail, isNameWithSpaces, isValidPhoneNumber, isNotSamePhoneNumber } from '../../../common/validation';
import { getSession, getAPPID, isMobile, renderElement, isDesktop, isTablet, isLoggedIn } from '../../../common/Helpers/index';
import { CTAProps, fullWidthColsSpan, nonDesktopQuery, noPadMobileStrict, StyledWrapper } from './shippingStyles';
import { nonMobileQuery } from '../../../common/styles';
import { eventDispatcher } from '../../../common/Tagging/index';
import { store } from '../../../../configureStore';

const mobileQuery = (style) => `@media (max-width: 480px) {${style}}`;

const Col = styled(VDSCol)`
  ${({ noTopMargin }) => !noTopMargin && 'margin-top: 24px;'}
  @media (min-width: 768px) {
    flex-basis: auto;
    padding-left: 6px;
    padding-right: 6px;
  }
  ${noPadMobileStrict}
`;
const Row = styled(VDSRow)`
  @media (min-width: 768px) {
    margin-left: -6px;
    margin-right: -6px;
  }
  &.contactInfoRow {
    ${noPadMobileStrict}
  }
  &.tabletDevice {
    @media (orientation: portrait) {
      .firstName,
      .lastName,
      .phoneNumber,
      .emailId {
        flex-basis: calc(calc(100% - 12px) / 2);
        max-width: calc(calc(100% - 12px) / 2);
      }
    }
  }
`;

class ContactInfoForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      // emailId: '',
      phoneNumber: '',
      enableCheckbox: true,
      emailError: false,
      emailErrorText: false,
      phoneError: false,
      phoneErrorText: '',
      fnameError: false,
      fnameErrorText: '',
      lnameError: false,
      lnameErrorText: '',
      email: '',
    };
    // this.width = '';
    // window.addEventListener('resize', this.update);
  }

  componentDidMount() {
    this.setState({
      // emailId: this.props.shippingAddress[0].address.emailId,
      email: this.props.shippingAddress[0].address.emailId,
      phoneNumber: this.props.shippingAddress[0].address.phoneNumber,
      firstName: this.props.shippingAddress[0].address.firstName,
      lastName: this.props.shippingAddress[0].address.lastName,
    });

    this.addEmailTooltipClickListener();
    // this.update();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props || prevState !== this.state) {
      this.addEmailTooltipClickListener();
    }
    if (
      (prevProps.emailMaxAttempts !== this.props.emailMaxAttempts && this.props.emailMaxAttempts) ||
      (prevProps.isEmailSuccess !== this.props.isEmailSuccess &&
        (this.props.isEmailSuccess?.valid === 'Manual_validation' ||
          this.props.isEmailSuccess?.valid === 'Fake' ||
          this.props.isEmailSuccess?.valid === 'Invalid' ||
          this.props.isEmailSuccess?.valid === 'false'))
    ) {
      this.setState({ emailError: true });
    }
  }

  componentWillUnmount() {
    renderElement(null, 'ispuContactEditCTA');
  }

  // update = () => {
  //   this.setState({
  //     width: window.innerWidth,
  //   });
  // };

  unParseNumber = (number) => {
    let unParsedNumber = '';
    if (number) {
      unParsedNumber = number.replace(/\./g, '');
    }
    return unParsedNumber;
  };

  handleContinue = () => {
    // let inputdata = {};
    // let param = {};
    // let cartDetails = {};
    const param = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      contactNumber: this.unParseNumber(this.state.phoneNumber),
      mtn: 'newLine1',
      checkBox: this.state.enableCheckbox,
    };

    let homePhoneAdded = false;
    const homePhoneResponse = this.props.cartDetails?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);
    if (homePhoneResponse.length > 0) {
      homePhoneAdded = true;
    }
    this.props.contactInfoUpdte(param, homePhoneAdded);
  };

  onChangeTextBox = (name, e) => {
    const val = e.target.value;
    if (name === 'firstName') {
      if (!val || !isNameWithSpaces(val?.trim())) {
        this.setState({ fnameError: true, fnameErrorText: 'Please enter a valid first name.' });
      } else {
        this.setState({ fnameError: false, fnameErrorText: '' });
      }
    } else if (name === 'lastName') {
      if (!val || !isNameWithSpaces(val?.trim())) {
        this.setState({ lnameError: true, lnameErrorText: 'Please enter a valid last name.' });
      } else {
        this.setState({ lnameError: false, lnameErrorText: '' });
      }
    } else if (name === 'emailId') {
      if (!val || !isValidEmail(val?.trim())) {
        this.setState({ emailError: true, emailErrorText: 'Please enter a valid email address.' });
        store.dispatch({ type: 'EMAIL_VALIDATION', response: { valid: 'false' } });
      } else {
        store.dispatch({ type: 'EMAIL_VALIDATION', response: { valid: 'true' } });
        this.setState({ emailError: false, emailErrorText: false, manualValidation: false });
      }
      this.setState({ email: val });
    } else if (name === 'phoneNumber') {
      if (!val || !isValidPhoneNumber(this.unParseNumber(val.trim()))) {
        if (this.unParseNumber(val).length !== 10) {
          this.setState({ phoneError: true, phoneErrorText: 'Please enter a valid phone number.' });
        } else if (this.unParseNumber(val.trim()) === '0000000000' || this.unParseNumber(val.trim()) === '9999999999') {
          this.setState({ phoneError: true, phoneErrorText: 'Please enter a valid phone number.' });
        } else if (isNotSamePhoneNumber(val?.replaceAll('-', '')?.trim())) {
          this.setState({ phoneError: true, phoneErrorText: 'Please enter a valid phone number.' });
        }
      }
      if (isValidPhoneNumber(this.unParseNumber(val.trim()))) {
        if (this.unParseNumber(val) === '0000000000' || this.unParseNumber(val) === '9999999999') {
          this.setState({ phoneError: true, phoneErrorText: 'Please enter a valid phone number.' });
        } else if (isNotSamePhoneNumber(val?.replaceAll('-', '')?.trim())) {
          this.setState({ phoneError: true, phoneErrorText: 'Please enter a valid phone number.' });
        } else {
          this.setState({ phoneError: false, phoneErrorText: null });
        }
      }
    }
    this.setState({ [name]: val });
  };

  addEmailTooltipClickListener = () => {
    const emailLink = document.getElementById('emailVal');
    if (emailLink) {
      const obj = {
        name: '',
        svars: {
          evar13: 'Click here to validate your email address',
        },
      };
      eventDispatcher('sendData', obj);
      emailLink.style.color = 'black';
      emailLink.style.textDecoration = 'underline';
      emailLink.style.cursor = 'pointer';
      emailLink.addEventListener('click', (event) => {
        event.preventDefault();
        emailLink.setAttribute('pointer-events', 'none');
        emailLink.setAttribute('cursor', 'not-allowed');
        const LQResponseData = getSession('LQResponse') ? JSON.parse(getSession('LQResponse')) : '';
        if (LQResponseData) {
          const postData = {};
          if (isLoggedIn()) {
            postData.mtn = LQResponseData?.output?.loginMtn;
          }
          postData.email = this.state.email;
          this.props.accMainEmailShippingVerify(postData);
        }
      });
    }
  };

  emailConfirm = (event, id) => {
    event.preventDefault();
    this.props.emailVaildationShippingAPI(this.state.email, id);
    const obj = {
      name: '',
      svars: {
        evar13: 'Please check your email. After validating your email address, click on confirm below',
      },
    };
    eventDispatcher('sendData', obj);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.shippingInfoState.updateContactInfo !== nextProps.shippingInfoState.updateContactInfo) {
      // on SSD update contact Info have to make api call for same and If only Success take it next page
      const { currentView, isCreditStatusAvailable, creditStatusLanded } = this.props;
      const isNoSlotsAvailable = getSession('isNoSlotsAvailable');
      const changeToSelf = getSession('changeToSelf');
      let updateView = '';
      // let updateView = this.props.currentView.FiveG; NoSlotsAppointment
      if (getAPPID() === 'NSE' && isNoSlotsAvailable !== 'Y' && changeToSelf !== 'Y') {
        updateView = currentView.CreditCheck;
      } else if (getAPPID() !== 'NSE' && isCreditStatusAvailable) {
        updateView = currentView.CreditStatus;
      } else if (isCreditStatusAvailable && !creditStatusLanded) {
        updateView = currentView.CreditStatus;
      } else if (isNoSlotsAvailable === 'Y' || changeToSelf !== 'Y') {
        if (
          (this.props.cartDetails?.shippingDetails && this.props.cartDetails.shippingDetails[0]?.shippingCost > 0) ||
          this.props.orderDetails.dueTodayAmount > 0
        ) {
          if (this.props.cartDetails?.payments?.length === 0) {
            updateView = currentView.Payment;
          } else if (this.props.cartDetails?.payments?.length > 0 && this.props.cartDetails.payments[0]?.paymentType) {
            updateView = currentView.OrderReview;
          }
        } else {
          updateView = currentView.OrderReview;
        }
        // setSession('isNoSlotsAvailable', 'N');
      } else if (this.props.orderDetails.dueTodayAmount > 0) {
        if (this.props.cartDetails && this.props.cartDetails.payments && this.props.cartDetails.payments.length === 0) {
          updateView = currentView.Payment;
        } else if (this.props.cartDetails?.payments?.length > 0 && this.props.cartDetails.payments[0]?.paymentType) {
          updateView = currentView.OrderReview;
        }
      } else {
        updateView = currentView.OrderReview;
      }
      // updateView = this.props.orderDetails.dueTodayAmount > 0 ? currentView.Payment : currentView.Tos;

      // this.props.toggleContactInfo();
      goToProcessStep(updateView, this.props.history);
    }
  }

  render() {
    const helperTextOptions = {
      helperText: this.props.shipping_info_email_legal_new,
      helperTextPlacement: 'bottom',
    };
    const { isEmailSuccess, accMainEmailVal } = this.props;
    const inputProps = isDesktop() ? { width: '398px' } : {};
    const colProps = { colSizes: { mobile: 4, tablet: 6, desktop: 6 }, styled: `${nonMobileQuery('')}` };
    const ISPUContactEditCTA = (
      <StyledWrapper styles={`margin-top:20px; ${nonDesktopQuery('margin-top:40px;')}`}>
        <Button className="ispuContactEditCTA" disabled={this.state.emailError || this.state.phoneError} onClick={this.handleContinue} {...CTAProps}>
          Continue
        </Button>
      </StyledWrapper>
    );
    const emailValidationBanner = this.props.contact_info_email_validation_banner_text_desktop?.split('<br>');
    const emailBannerTitle = emailValidationBanner.length > 0 && emailValidationBanner[0];
    const emailBannerSubtitle = emailValidationBanner.length > 1 && emailValidationBanner[1].replace('<email address>', this.state.email);
    const emailBannerConfirmText = emailValidationBanner.length > 2 && emailValidationBanner[2];
    const validateEmailResponse = this.props?.isEmailSuccess?.valid;
    if (validateEmailResponse === 'Valid' || validateEmailResponse === 'White_listed' || validateEmailResponse === 'true') {
      this.setState({ emailError: false, manualValidation: false });
    } else if (validateEmailResponse === 'Fake' || validateEmailResponse === 'Invalid' || validateEmailResponse === 'false') {
      this.setState({ emailError: true, manualValidation: false });
    } else if (validateEmailResponse === 'Manual_validation') {
      this.setState({ emailError: true, manualValidation: true });
    }

    return (
      <React.Fragment>
        <div className="ispuContactEditContainer">
          {!this.props.shippingAddress[0].storeinfo && (
            <Row className="shipping_types marginTopBottom10">
              <Col xs={12} md={6} lg={6}>
                <Line type="secondary" surface="light" />
              </Col>
            </Row>
          )}
          <Row>
            <Body primitive="p" size="medium" bold>
              {!this.props.shippingAddress[0].storeinfo ? (
                <div className="marginLeft10"> Contact Information </div>
              ) : (
                <div className="marginLeft10"> Pickup contact information</div>
              )}
            </Body>
          </Row>
          <Grid>
            {this.props.shippingAddress[0].storeinfo && (
              <Row className={`${isTablet() ? 'tabletDevice' : ''} contactInfoRow`}>
                <Col xs={6} md={3} lg={3} {...colProps} className="firstName">
                  <ReqInput
                    defaultValue={this.props.cartDetails.primaryUserInfo.firstName}
                    type="text"
                    id="firstName"
                    name="firstName"
                    label="First name*"
                    onChange={(e) => this.onChangeTextBox('firstName', e)}
                    error={this.state.fnameError}
                    errorText={this.state.fnameErrorText}
                    isDisabled
                    {...inputProps}
                  />
                </Col>
                <Col xs={6} md={3} lg={3} {...colProps} className="lastName">
                  <ReqInput
                    defaultValue={this.props.cartDetails.primaryUserInfo.lastName}
                    type="text"
                    id="lastName"
                    name="lastName"
                    label="Last name*"
                    onChange={(e) => this.onChangeTextBox('lastName', e)}
                    error={this.state.lnameError}
                    errorText={this.state.lnameErrorText}
                    isDisabled
                    {...inputProps}
                  />
                </Col>
              </Row>
            )}
            <Row className={`${isTablet() ? 'tabletDevice' : ''} contains-PII contactInfoRow`} data-cs-mask>
              <Col {...colProps} className="emailId">
                <div>
                  <EmailInput
                    defaultValue={this.props.shippingAddress[0].address.emailId}
                    value={this.state.email}
                    id="shippingInfoVdsEmail"
                    name="emailId"
                    type="text"
                    placeholder=""
                    ariaLabel="Email Address Required Input Fields"
                    required
                    success={
                      (isEmailSuccess?.valid === 'Valid' || isEmailSuccess?.valid === 'White_listed' || isEmailSuccess?.valid === 'true') &&
                      !this.props.emailMaxAttempts
                    }
                    label="Email address"
                    onChange={(e) => this.onChangeTextBox('emailId', e)}
                    data-cs-mask
                    error={
                      this.state.emailError ||
                      isEmailSuccess?.valid === 'Manual_validation' ||
                      isEmailSuccess?.valid === 'Invalid' ||
                      isEmailSuccess?.valid === 'Fake' ||
                      this.props.emailMaxAttempts
                    }
                    errorText={this.state.email === '' ? 'Required' : this.state.emailErrorText ? this.state.emailErrorText : ''}
                    emailAPICall={!this.props.emailMaxAttempts ? this.props.emailVaildationShippingAPI : null}
                    isValidEmail={isEmailSuccess}
                    contactEmailCTA={this.props.contactEmailCTA}
                    pageName="shippingInfo"
                    {...helperTextOptions}
                    existEmail={this.props.shippingAddress[0].address.emailId}
                    setEmailValidationdata={this.props.setEmailValidationdata}
                    hideBlurFlag
                    {...inputProps}
                  />
                </div>
                {this.state.manualValidation &&
                  isMobile() &&
                  !accMainEmailVal?.success &&
                  this.props.contact_info_manual_email_validation_text_mobile &&
                  !this.state.emailErrorText && (
                    <div>
                      <Micro primitive="span">{parse(this.props.contact_info_manual_email_validation_text_mobile)}</Micro>
                      <div className="displayInlineFlex">
                        <VdsTooltip id="emailValTooltip" direction="top" role="tooltip" tabIndex="0" size="small">
                          <span>{this.props.contact_info_email_validation_tooltip_text}</span>
                        </VdsTooltip>
                      </div>
                    </div>
                  )}
                {this.state.manualValidation &&
                  !isMobile() &&
                  !accMainEmailVal?.success &&
                  this.props.contact_info_manual_email_validation_text_desktop &&
                  !this.state.emailErrorText && (
                    <div>
                      <Micro primitive="span">{parse(this.props.contact_info_manual_email_validation_text_desktop)}</Micro>
                      <div className="displayInlineFlex">
                        <VdsTooltip id="emailValTooltip" direction="top" role="tooltip" tabIndex="0" size="small">
                          <span>{this.props.contact_info_email_validation_tooltip_text}</span>
                        </VdsTooltip>
                      </div>
                    </div>
                  )}
                {this.state.manualValidation && this.state.emailError && accMainEmailVal?.success && (
                  <Notification
                    type="info"
                    title={emailBannerTitle}
                    subtitle={parse(`${emailBannerSubtitle}<br>${emailBannerConfirmText}`)}
                    hideCloseButton
                    className="marginTop15"
                    layout="vertical"
                    buttonData={[
                      {
                        children: 'Confirm',
                        onClick: (event) => this.emailConfirm(event, 'shippingInfoVdsEmail'),
                        'data-track': '{"type":"link","name":"email-validation-confirm"}',
                      },
                    ]}
                  />
                )}
              </Col>
              <Col {...colProps} className="phoneNumber">
                <ReqInput
                  defaultValue={normalizePhoneNumber(this.props.shippingAddress[0].address.phoneNumber)}
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  error={this.state.phoneError}
                  errorText={this.state.phoneErrorText}
                  success={!this.state.phoneError}
                  ariaLabel="Mobile Phone number Required Input Fields"
                  label="Mobile phone number*"
                  onChange={(e) => this.onChangeTextBox('phoneNumber', e)}
                  {...inputProps}
                />
              </Col>
            </Row>
            <Row className="contactInfoRow">
              <Col {...fullWidthColsSpan} noTopMargin>
                <StyledWrapper styles={`${mobileQuery('margin: 8px 0px 32px;')} margin: 32px 0px 24px;`}>
                  <Body primitive="p" size={isMobile() ? 'small' : 'large'} color={isMobile() ? '#6F7171' : ''}>
                    We need a phone number to call you about your order.
                  </Body>
                </StyledWrapper>
              </Col>
            </Row>
            <Row className="contactInfoRow">
              <Col analyticstrack="5G-specialTextUpdatesFlag" {...fullWidthColsSpan} noTopMargin>
                <Checkbox
                  className="checkbox"
                  id="consent"
                  component="input"
                  type="checkbox"
                  checkboxClass="displayInlineBlock pad6 noLeftPad"
                  selected={this.state.enableCheckbox}
                  aria-checked={this.state.enableCheckbox}
                  checked={this.state.enableCheckbox}
                  onChange={(event) => {
                    this.setState({
                      enableCheckbox: event.target.checked,
                    });
                    if (event.key === 'Enter') {
                      this.setState((prevState) => ({
                        enableCheckbox: !prevState.enableCheckbox,
                      }));
                    }
                  }}
                  tabIndex="0"
                >
                  <Body primitive="p" size="large">
                    Send me text updates.
                  </Body>
                  <Body primitive="p" size="small" color={isMobile ? '' : '#747676'}>
                    Message and data rates may apply.
                  </Body>
                </Checkbox>
              </Col>
            </Row>
            <Row>
              <Col {...fullWidthColsSpan}>{isDesktop() ? renderElement(ISPUContactEditCTA, 'ispuContactEditCTA', true) : ISPUContactEditCTA}</Col>
            </Row>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

ContactInfoForm.defaultProps = {
  contact_info_email_validation_banner_text_desktop:
    "Please check your email.<br> We've sent an email to <email address>. After validating your email address<br>click Confirm below.",
};

ContactInfoForm.propTypes = {
  // contactDetails: PropTypes.object,
  contactInfoUpdte: PropTypes.func,
  shippingInfoState: PropTypes.object,
  // shippingDetails: PropTypes.object,
  shippingAddress: PropTypes.object,
  currentView: PropTypes.object,
  orderDetails: PropTypes.object,
  history: PropTypes.object,
  cartDetails: PropTypes.object,
  isCreditStatusAvailable: PropTypes.bool,
  creditStatusLanded: PropTypes.bool,
  isEmailSuccess: PropTypes.string,
  emailMaxAttempts: PropTypes.string,
  accMainEmailVal: PropTypes.object,
  // contactEditProps: PropTypes.object,
  // emailAPICall: PropTypes.func,
  emailVaildationShippingAPI: PropTypes.func,
  contactEmailCTA: PropTypes.string,
  // accMainEmailVerify: PropTypes.func,
  accMainEmailShippingVerify: PropTypes.func,
  setEmailValidationdata: PropTypes.func,
  shipping_info_email_legal_new: PropTypes.string,
  contact_info_email_validation_banner_text_desktop: PropTypes.string,
  contact_info_manual_email_validation_text_mobile: PropTypes.string,
  contact_info_email_validation_tooltip_text: PropTypes.string,
  contact_info_manual_email_validation_text_desktop: PropTypes.string,
};

export default withRouter(ContactInfoForm);
